module.exports = __webpack_public_path__ + "static/media/img2-1.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/nutricheck_foliar/K/img2-1.png
// module id = 2438
// module chunks = 3